import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import {
  Icon,
  PageTitle,
  PageDiv,
  Message,
  Button,
} from './Style';
import TickIcon from '../../assets/tick-icon.svg'; // Adjust the path as necessary

const EmailConfirmationSuccess = () => {

  const navigate = useNavigate();
  const { t } = useTranslation();
  const handleContinue = () => {
    navigate('/login');
  };

  return (
    <PageDiv>
      <Icon src={TickIcon} alt="Success Icon" />
      <PageTitle>{t("auth.verificationPages.success.title")}</PageTitle>
      <Message>{t("auth.verificationPages.success.text")}</Message>
      <Button onClick={handleContinue}>{t("auth.verificationPages.success.button")}</Button>
    </PageDiv>
  );
};

export default EmailConfirmationSuccess;
